export class AutomotiveAftermarketReportLoad {
  public static readonly type = '[AutomotiveAftermarketReport] Load';
}

export class AutomotiveAftermarketReportInitialState {
  public static readonly type = '[AutomotiveAftermarketReport] Set Initial State';
}
